<template>
  <div>
    <ul v-if="listType === 'unordered'" class="tw-list-none tw-text-gray-900 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg">
      <slot />
    </ul>
    <ol v-else class="tw-list-none tw-text-gray-900 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg">
      <slot />
    </ol>
  </div>
</template>
<script>
export default {
  props: {
    listType: {
      type: String,
      default: "unordered",
    },
  },
};
</script>
